import { Flex, theme } from 'antd';
import { ShowPerformanceTableEcho } from '@/components/tables/ShowPerformanceTableEcho';
import useShowPerformanceData from './usePerformanceData';
import type { TableContainerProps } from '@/types';

/**
 * This is the container for the show performance table.
 * It is used to display the show performance data in a table.
 *
 * @param selectedNetwork - The selected network.
 * @param dateRange - The date range.
 * @returns The show performance table container.
 */
const ShowPerformanceTableContainerEcho = ({ selectedNetwork, dateRange }: TableContainerProps) => {
  const { token } = theme.useToken();
  const { data: showPerformanceData, isPending: isLoading } = useShowPerformanceData(
    selectedNetwork,
    dateRange,
    true
  );

  return (
    <Flex vertical gap={token.paddingLG} style={{ padding: token.paddingLG }}>
      <ShowPerformanceTableEcho data={showPerformanceData ?? []} isLoading={isLoading} />
    </Flex>
  );
};

export default ShowPerformanceTableContainerEcho;
